import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  IconButton,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import { ContactAlerts, useContactSubmit } from '../services/contactService';

const ContactSupportDialog = ({ open, onClose }) => {
  const { user } = useAuth();
  const { submit, loading, error, sent, resetStatus } = useContactSubmit();
  const [comments, setComments] = useState('');

  const handleSubmit = async () => {
    await submit({
      type: 'support',
      comments,
      name: user?.user_metadata?.first_name && user?.user_metadata?.last_name
        ? `${user.user_metadata.first_name} ${user.user_metadata.last_name}`
        : undefined,
      email: user?.email,
    });
  };

  const handleClose = () => {
    setComments('');
    resetStatus();
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        Contact Support
        <IconButton onClick={handleClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 1 }}>
          <ContactAlerts error={error} sent={sent} />
          <TextField
            fullWidth
            multiline
            rows={6}
            label="How can we help you?"
            placeholder="Please describe your question, issue, or request..."
            value={comments}
            onChange={(e) => setComments(e.target.value)}
            inputProps={{ maxLength: 500 }}
            helperText={`${comments.length}/500 characters`}
          />
        </Box>
      </DialogContent>
      
      <DialogActions>
        <Button onClick={handleClose}>{sent ? 'Close' : 'Cancel'}</Button>
        {!sent && (
          <Button onClick={handleSubmit} variant="contained" disabled={loading}>
            {loading ? 'Sending...' : 'Send Request'}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ContactSupportDialog;
